/** Minimal recipient shape for routing-complexity checks. */
export type RecipientForWorkflowCheck = {
  role: string
  isGroup?: boolean
}

/**
 * Whether the envelope is complex enough that the workflow builder is worth
 * offering. Simple sends stay on today's sidebar list.
 */
export function needsWorkflowStep(
  recipients: RecipientForWorkflowCheck[],
  routingEnabled: boolean,
): boolean {
  if (routingEnabled) return true
  if (recipients.some((r) => r.isGroup)) return true
  if (recipients.some((r) => r.role === 'cc' || r.role === 'needs_to_view')) return true
  const signing = recipients.filter((r) => r.role === 'signer' || r.role === 'witness')
  if (signing.length <= 1 && recipients.length <= 1) return false
  if (signing.length === 2 && !recipients.some((r) => r.isGroup)) return false
  return signing.length > 2
}

/** True when today's flat sidebar is enough — one signer, or two in order with no branch or group. */
export function fitsSimpleSidebar(
  recipients: RecipientForWorkflowCheck[],
  routingEnabled: boolean,
): boolean {
  return !needsWorkflowStep(recipients, routingEnabled)
}
